<template>
    <FloatingPanel>
        <div class="act::canvas-blocks-modules-act-BlockPanel">
            <accordion-input :accordion="true" :open="true">
                <template #label>
                    <div class="font-medium">Verwijs naar</div>
                </template>
                <template #content>
                    <small class="block mb-5 text-gray-500 text-muted">
                        (OPTIONEEL) Kies een pagina om naar door te verwijzen. Als er geen pagina gekozen is worden alle
                        programma items getoond.
                    </small>
                    <website-page-selector
                        ref="websitePageSelector"
                        :value="options.linkWebsitePageId"
                        @update:value="setLink($event)"
                        language="nl"
                    />
                </template>
            </accordion-input>

            <CommonInputs :options="options" />
        </div>
    </FloatingPanel>
</template>

<script>
import AbstractPanel from '@galaxy/modules/Canvas/resources/js/editor/website/editors/AbstractPanel.vue';
import FloatingPanel from '@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/FloatingPanel.vue';
import CommonInputs from '@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/CommonInputs.vue';
import AccordionInput from '@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/helpers/Input';
import WebsitePageSelector from '@galaxy/modules/Website/resources/js/admin/WebsitePageSelector.vue';

export default {
    extends: AbstractPanel,

    components: {
        FloatingPanel,
        CommonInputs,
        AccordionInput,
        WebsitePageSelector,
    },

    methods: {
        setLink(websitePageId) {
            // Set
            this.$set(this.options, 'linkWebsitePageId', websitePageId);
        },
    },
};
</script>
